// Recipient routing category — which agency contact receives a given notification.
export const EMAIL_TYPES = {
  CONFIRMATION_BOOKING_INVOICE: 'confirmation-booking-invoice',
};

// Canonical identifiers for every email the platform sends. Senders tag a send with one of
// these (via `meta.type`) so it is recorded on the EmailLog `type` field; untagged sends fall
// back to 'unknown'. Distinct from EMAIL_TYPES above, which categorizes recipients.
export const EMAIL_LOG_TYPES = {
  RESET_PASSWORD_AGENT: 'reset-password-agent',
  RESET_PASSWORD_CLIENT: 'reset-password-client',
  RESET_PASSWORD_PARTNER: 'reset-password-partner',
  VERIFY_AGENT: 'verify-agent',
  VERIFY_CLIENT: 'verify-client',
  LEAD: 'lead',
  ENQUIRY_EXAMPLE_CLIENT: 'enquiry-example-client',
  ENQUIRY_EXAMPLE_WIZARD: 'enquiry-example-wizard',
  REQUEST_HOLD: 'request-hold',
  QUOTE_ITINERARY: 'quote-itinerary',
  HOLD_ITINERARY: 'hold-itinerary',
  CANCEL_HOLD_ITINERARY: 'cancel-hold-itinerary',
  CONFIRM_ITINERARY: 'confirm-itinerary',
  CONFIRM_BOOKING: 'confirm-booking',
  ITINERARY_PROBLEM: 'itinerary-problem',
  PAYMENT_RECEIPT_AGENT: 'payment-receipt-agent',
  PAYMENT_RECEIPT_CLIENT: 'payment-receipt-client',
  COST_CHANGE: 'agent-cost-changes',
  CONSULTANT_MESSAGE: 'consultant-message',
  INTERNATIONAL_FLIGHTS: 'international-flights',
  INVOICE_GENERATION: 'invoice-generation',
  INVOICES_UPDATED: 'invoices-updated',
  WIRE_TRANSFER_DETAILS: 'wire-transfer-details',
};
